import { createContainer } from 'unstated-next'
import useSWR from 'swr'
import { useCallback } from 'react'
import { purchaseSubscriptionRequest } from '../api/purchase'
import { notify } from '../../../../Helpers/Notifications'
import {
  deleteSubscriptionInvite,
  inviteForSubscriptionOffer,
} from '../api/invite'
import UserStoreNext from '../../../UserAuth/Store/user-store-next'
import { filter, propEq } from 'ramda'
import PaymentApis from '../../../../Modules/payment-v2/api/payment'

const template = 'SUBSCRIPTION_INVITATION_JUL_05'

const activeParser = filter(propEq('status', 'ACTIVE'))

const PricingStore = createContainer(() => {
  const { data: profile } = UserStoreNext.useContainer()

  const { data: subscriptions, error } = useSWR(`/subscription/models`)

  const { data: activeSubscription } = useSWR(
    profile.id ? [`/subscriptions`, activeParser] : null,
  )

  const { data: subscriptionInvites, mutate } = useSWR(
    false && profile.id
      ? [
          `/invitations`,
          (invites) => {
            return {
              receivedInvitations: invites.receivedInvitations.filter(
                (x) => x.template_type === template,
              ),
              sentInvitations: invites.sentInvitations.filter(
                (x) => x.template_type === template,
              ),
            }
          },
        ]
      : null,
  )

  const purchaseSubscription = useCallback(async (id) => {
    return await purchaseSubscriptionRequest(id)
  }, [])

  const inviteUser = useCallback(
    async (email) => {
      const success = await inviteForSubscriptionOffer(email)
      if (success) {
        await mutate()
        notify('success', 'Successfully sent the invitation.')
      }

      return success
    },
    [mutate],
  )

  const deleteInvite = useCallback(
    async (id) => {
      const success = await deleteSubscriptionInvite(id)
      if (success) {
        await mutate()
        notify('success', 'Successfully deleted the invitation.')
      }

      return success
    },
    [mutate],
  )

  const addDiscountCode = useCallback(async (code, bill, setBill) => {
    if (!code) {
      return false
    }

    const updatedBill = await PaymentApis.redeemDiscountCoupon(
      bill?.id,
      code.toUpperCase(),
    )

    if (updatedBill) {
      console.log({ updatedBill })
      setBill(updatedBill)
    }

    return Boolean(updatedBill)
  }, [])

  return {
    subscriptions: subscriptions || [],
    loading: !subscriptions,
    loadFailed: Boolean(error),
    activeSubscription,
    subscriptionInvites,
    purchaseSubscription,
    inviteUser,
    mutate,
    deleteInvite,
    addDiscountCode,
  }
})

export default PricingStore
